import { type Theme } from "@mui/material"
import { createContext } from "react"

type ThemeMode = "light" | "system" | "dark"
type AudienceMode = "thai" | "international"
type SkillsStyle = "simple" | "highlighted"

interface ThemeContextType {
    theme: Theme
    themeSettings: {
        mode: ThemeMode
        isDarkMode: boolean
        setThemeMode: (mode: ThemeMode) => void
        surfaceColor: string
        backgroundColor: string
        borderColor: string
        faintColor: string
    }
    layout: {
        sidebarWidth: number
        pageWidth: number
        pageHeight: number
        pagePadding: number
        verticalSpacing: number
    }
    breakpoints: {
        isSmallScreen: boolean
        isMediumScreen: boolean
        isLargeScreen: boolean
        isPdfMode: boolean
        isFullPage: boolean
    }
    audience: {
        mode: AudienceMode
        setAudienceMode: (mode: AudienceMode) => void
    }
    skills: {
        style: SkillsStyle
        setSkillsStyle: (style: SkillsStyle) => void
        textColor: string
    }
    visibility: {
        visibilityTier: 1 | 2 | 3
    }
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)
